import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Sirve si tengo más de 40 años?',
    answer: 'Sí, está diseñado especialmente para eso. El Wall Pilates es de bajo impacto, protege las articulaciones y trabaja con el cuerpo tal como está hoy — no como estaba a los 25.'
  }, {
    question: '¿Y si nunca hice ejercicio?',
    answer: 'Perfecto para empezar. Cada ejercicio tiene un video corto explicado paso a paso. No necesitás experiencia previa ni saber nada de fitness.'
  }, {
    question: '¿Cuánto tiempo por día necesito?',
    answer: '20 a 30 minutos, 4 días a la semana. Si podés sacar ese tiempo, ya tenés todo lo que necesitás.'
  }, {
    question: '¿En cuánto tiempo veo resultados?',
    answer: 'La mayoría nota cambios entre la semana 2 y 3 — menos hinchazón, más energía, ropa que entra diferente. A los 28 días el cambio es visible.'
  }, {
    question: '¿Necesito equipamiento o gym?',
    answer: 'No. Solo una pared y tu propio cuerpo. Podés hacerlo en tu cuarto, en el living, en cualquier lado.'
  }, {
    question: '¿Y si tengo dolor de rodillas o espalda?',
    answer: 'El programa está pensado exactamente para eso. La pared actúa como soporte, elimina el impacto y protege tus articulaciones. Muchas clientas con dolor crónico pudieron empezar gracias a esto.'
  }, {
    question: '¿Cuándo recibo el material?',
    answer: 'Inmediatamente después de comprar te llega todo por mail — el programa completo + los 10 bonos. Acceso instantáneo desde tu celular.'
  }, {
    question: '¿Y si no me gusta?',
    answer: 'Tenés 7 días para probarlo completo. Si no te convence, escribinos y te devolvemos el 100% de tu dinero. Sin preguntas, sin formularios.'
  }];
  return <section className="py-12 md:py-16 bg-gray-50" data-id="element-84">
      <div className="max-w-2xl mx-auto px-4 md:px-6" data-id="element-85">
        <h2 className="font-display text-3xl md:text-4xl text-center mb-10 text-gray-900" data-id="element-86">
          Preguntas frecuentes
        </h2>

        <div className="space-y-3" data-id="element-87">
          {faqs.map((faq, i) => <div key={i} className="bg-white border border-gray-200 rounded-2xl overflow-hidden" data-id="element-88">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between px-5 py-4 text-left" data-id="element-89">
                <span className="font-bold text-base text-gray-900 pr-4" data-id="element-90">
                  {faq.question}
                </span>
                {openIndex === i ? <MinusIcon className="w-5 h-5 text-brand-pink-600 flex-shrink-0" data-id="element-91" /> : <PlusIcon className="w-5 h-5 text-brand-pink-600 flex-shrink-0" data-id="element-92" />}
              </button>
              {openIndex === i && <div className="px-5 pb-4" data-id="element-93">
                  <p className="text-gray-600 text-sm leading-relaxed" data-id="element-94">{faq.answer}</p>
                </div>}
            </div>)}
        </div>

        <div className="mt-10 text-center" data-id="element-95">
          <CTAButton size="large" data-id="element-96">EMPEZAR — $14.990</CTAButton>
          <p className="text-xs text-gray-400 mt-3" data-id="element-97">🛡️ Garantía 7 días · Acceso inmediato</p>
        </div>
      </div>
    </section>;
}